import update from 'immutability-helper';
import venueApi from '../lib/api/venue';
// ------------------------------------
// Constants
// ------------------------------------

export const RECEIVE_VENUE = 'VENUE/LOAD_SUCCESS';
export const LOAD_VENUE = 'VENUE/LOADING';

export function receiveVenue(venue) {
	return {
		type: RECEIVE_VENUE,
		venue,
	};
}

export function startLoading() {
	return {
		type: LOAD_VENUE,
	};
}

export function fetchVenue(id) {
	return async (dispatch, getState) => {
		dispatch(startLoading());
		const venue = await venueApi.getVenue(getState().merchant.merchantId, id);
		dispatch(receiveVenue(venue));
	};
}

export function fetchVenueIfNeeded(id) {
	return (dispatch, getState) => {
		if (!getState().venue.elements[id]) {
			return dispatch(fetchVenue(id));
		}
		return Promise.resolve();
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[RECEIVE_VENUE]: (state, action) => update(state, {
		elements: {
			[action.venue.storageId]: { $set: action.venue },
		},
		isLoading: { $set: false },
	}),
	[LOAD_VENUE]: (state) => update(state, {
		isLoading: { $set: true },
	}),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
	elements: {},
	selected: null,
	isLoading: false,
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
